import {useState} from "react";
import SmallSpinner from "../SmallSpinner";

function PayInvoice({invoices, selectedInvoice, setRefresh}) {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const invoice = invoices.find(value => value.id === selectedInvoice);
	const paymentMethodName = invoice?.paymentMethodName ?? "";
	const isStripeTransfer = paymentMethodName.toLowerCase().includes("stripe");
	const stripeTransferStatus = invoice?.stripeTransferStatus;
	const submitButtonTitle = stripeTransferStatus === 'initiated' ? 'Stripe transfer initiated' : (isStripeTransfer ? 'Pay via Stripe' : 'Mark invoice paid');

	function markInvoicePaid(invoice) {
		return fetch(process.env.REACT_APP_endPoint + "/v1/invoices/" + invoice.id, {
			headers: {
				'Content-Type': 'application/json'
			},
			credentials: "include",
			method: "PUT",
			body: JSON.stringify({
				isLsp: invoice.isLsp,
				paymentMethodId: invoice.paymentMethodId
			})
		});
	}

	function payViaStripe(invoice) {
		return fetch(process.env.REACT_APP_endPoint + "/v1/invoices/" + invoice.id + "/pay-stripe", {
			headers: {
				'Content-Type': 'application/json'
			},
			credentials: "include",
			method: "POST",
			body: JSON.stringify({
				isLsp: invoice.isLsp,
				paymentMethodId: invoice.paymentMethodId
			})
		});
	}

	async function onSubmit(evt) {
		evt.preventDefault();
		if (invoice) {
			setLoading(true);
			setError(null);

			try {
				const response = isStripeTransfer ? await payViaStripe(invoice) : await markInvoicePaid(invoice);
				const jsonResponse = await response.json();
				if (response.status === 200) {
					setRefresh(prevState => !prevState);
				} else if (response.status === 409) {
					setError(jsonResponse.error);
				}
			} catch (e) {
				console.error(e);
			}
			finally {
				setLoading(false);
			}
		}
	}

	return (
		<form onSubmit={onSubmit}>
			<div className={"mb-3"}>
				<span className={"form-label"}>Payment method: </span>
				<strong>{paymentMethodName || "—"}</strong>
				{error && <div className={"alert alert-danger mt-3"}>{error}</div>}
			</div>

			<div className="d-flex justify-content-between">
				<button className={"btn btn-success"} type={"submit"} disabled={loading || !invoice || stripeTransferStatus === 'initiated'}>{loading ? <SmallSpinner />:submitButtonTitle}</button>
				<button className={"btn btn-primary"} type={"button"} onClick={(evt) => {
					const iframe = document.getElementById("iframe");
					if (iframe.srcdoc) {
						iframe.contentWindow.print();
					}
				}}>Print invoice</button>
			</div>
		</form>
	);
}

export default PayInvoice;
